<template>

  <section class="ContentSectionWithFeatureCards">

    <Container>
      <CenteredTextBox :content="content" />
    </Container>

    <FeatureCards v-if="content.features && content.features.length > 0" :features="content.features" class="featureCards" />

  </section>

</template>

<script>
import CenteredTextBox from '../blocks/CenteredTextBox.vue'
import FeatureCards from './FeatureCards.vue'

export default {
  components: {
    CenteredTextBox,
    FeatureCards,
  },
  props: {
    content: {
      type: Object,
      default: Object,
    },
  },
}
</script>

<style scoped>
.ContentSectionWithFeatureCards {
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
  background-color: var(--bg-color-white);
}
.featureCards {
  margin-top: var(--spacing-11);
}
</style>
